import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Why from "@/components/site/Why";
import Numbers from "@/components/site/Numbers";
import Services from "@/components/site/Services";
import Principles from "@/components/site/Principles";
import Focus from "@/components/site/Focus";
import LeadershipPreview from "@/components/site/LeadershipPreview";
import Partners from "@/components/site/Partners";
import Opportunity from "@/components/site/Opportunity";
import InsightsPreview from "@/components/site/InsightsPreview";
import BrandMark from "@/components/site/BrandMark";
import Statement from "@/components/site/Statement";
import Newsletter from "@/components/site/Newsletter";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
    return (
        <main data-testid="home-page" className="bg-bone text-ink">
            <Nav />
            <Hero />
            <Why />
            <Numbers />
            <Services />
            <Principles />
            <Focus />
            <LeadershipPreview />
            <Partners />
            <Opportunity />
            <InsightsPreview />
            <BrandMark />
            <Statement />
            <Newsletter />
            <Contact />
            <Footer />
        </main>
    );
}
